import { render, staticRenderFns } from "./CardBody.vue?vue&type=template&id=fbcc51e8&scoped=true"
import script from "./CardBody.vue?vue&type=script&lang=js"
export * from "./CardBody.vue?vue&type=script&lang=js"
import style0 from "./CardBody.vue?vue&type=style&index=0&id=fbcc51e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbcc51e8",
  null
  
)

export default component.exports